import React, { FC } from 'react';
import { DynamicComponent } from '@/components';
import { TypeComponentGridFields } from '@/core/generated-types';

const DESKTOP_CLASSES: Record<string, string> = {
  '1': 'lg:grid-cols-1',
  '2': 'lg:grid-cols-2',
  '3': 'lg:grid-cols-3',
  '4': 'lg:grid-cols-4',
};

const TABLET_CLASSES: Record<string, string> = {
  '1': 'md:grid-cols-1',
  '2': 'md:grid-cols-2',
  '3': 'md:grid-cols-3',
  '4': 'md:grid-cols-4',
};

const MOBILE_CLASSES: Record<string, string> = {
  '1': 'grid-cols-1',
  '2': 'grid-cols-2',
  '3': 'grid-cols-3',
  '4': 'grid-cols-4',
};

const SPACING_CLASSES: Record<string, string> = {
  '4': 'gap-x-2 md:gap-x-4 gap-y-4',
  '6': 'gap-6',
  '8': 'gap-8',
  '10': 'gap-10',
};

export interface ComponentGridProps extends TypeComponentGridFields {
  isHidden?: boolean | undefined;
  forceOneComponentPerRowOnTablet?: boolean;
  removeContainer?: boolean;
}

const ComponentGrid: FC<ComponentGridProps> = ({
  components,
  spacing = 4,
  mobileColCount = 1,
  tabletColCount = 2,
  desktopColCount = 3,
}) => {
  if (!components?.length) {
    return null;
  }

  return (
    <div
      className={`mx-auto md:-mt-1.5 grid items-start ${SPACING_CLASSES[spacing]}
        ${DESKTOP_CLASSES[desktopColCount]} ${TABLET_CLASSES[tabletColCount]} ${MOBILE_CLASSES[mobileColCount]}`}
    >
      {components.map((component, i) => (
        <DynamicComponent
          component={component}
          key={`${component.sys.id}-${i}`}
        />
      ))}
    </div>
  );
};

export default React.memo(ComponentGrid);
